"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSessionManager = createSessionManager;
const AmplifyAuthAdapter_1 = require("./AmplifyAuthAdapter");
const SessionManager_1 = require("./SessionManager");
/**
 * Construct a fully-wired SessionManager from an Amplify config.
 *
 * This is the recommended entry point for app bootstrap code on WEB. Native
 * apps use `createNativeSessionManager` from `@home-health-notify/auth/native`
 * — same underlying AmplifyAuthAdapter, but that factory also injects a
 * SecureStore-backed KeyValueStorage so tokens don't land in AsyncStorage
 * plaintext on device.
 *
 * @example
 *   import { createSessionManager } from "@home-health-notify/auth";
 *
 *   const sessionManager = createSessionManager({
 *     Auth: {
 *       Cognito: {
 *         userPoolId: env.USER_POOL_ID,
 *         userPoolClientId: env.USER_POOL_CLIENT_ID,
 *         loginWith: { oauth: { ...oauthConfig } },
 *       },
 *     },
 *     cookieStorage: env.COOKIE_DOMAIN ? { domain: env.COOKIE_DOMAIN } : undefined,
 *   });
 *
 *   // Pass to <AuthProvider sessionManager={sessionManager}>
 *   // Pass to AdapterFactory via sessionManager.getAdapter() if needed
 */
function createSessionManager(config) {
    const adapter = new AmplifyAuthAdapter_1.AmplifyAuthAdapter(config);
    return new SessionManager_1.SessionManager(adapter);
}
